<nav v-if="numberOfPages > 1" class="tt-o-pagination" role="navigation" :aria-label="title">
  <tt-button v-if="!hideBackNext" class="tt-o-pagination__back" @click="back" :type="buttonType" :aria-label="$msg('pagination.goBack')" :disabled="!hasPrevious">
    <tt-icon name="caret-left"></tt-icon>
  </tt-button>
  <ul v-if="!hidePageList" class="tt-o-page-list">
    <li v-for="p in pageList"
        class="tt-o-page-list__number"
        :class="{'tt-is-active': p.isCurrentPage, 'tt-o-page-list__number-jump': p.jumpTo}"
        :key="p.page">
      <span v-if="p.isEllipsis" class="tt-o-page-list__gap">&hellip;</span>
      <a v-else
          href=""
          class="tt-o-page-list__link tt-u-ignore-default"
          :aria-label="p.label"
          :aria-current="p.isCurrentPage"
          @click.prevent="goToPage(p.page)"
          @keydown.enter.prevent="goToPage(p.page)"
          rel="nofollow">{{p.page}}</a>
    </li>
  </ul>
  <slot></slot>
  <tt-button v-if="!hideBackNext" class="tt-o-pagination__next" @click="next" :type="buttonType" :aria-label="$msg('pagination.goNext')" :disabled="!hasMore">
    <tt-icon name="caret-right"></tt-icon>
  </tt-button>
</nav>
